import { getPublicConfig } from "@/shared/config/config"

export function login() {
  window.location.href = `${getPublicConfig().cmApiBaseUrl}/auth/login`
}
